import React from "react"

import StatusNotification from "@irati/ui/src/StatusNotification"
import {RouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"

import {SETTINGS_LOGIN_INTEGRATION} from "../../routes/routeConfig"

interface Props {
  isEnabled: boolean
}

const PeopleDirectoryHeader: React.FC<Props> = ({isEnabled}) => {
  return (
    <StatusNotification
      type="PairLabels"
      labelState={isEnabled}
      labelText={{
        enabled: "admin.containers.manageUsers.peopleDirectoryHeader.enabled",
        disabled: "admin.containers.manageUsers.peopleDirectoryHeader.disabled"
      }}
      notificationText={{
        enabled: "admin.containers.manageUsers.peopleDirectoryHeader.statusEnabled",
        disabled: "admin.containers.manageUsers.peopleDirectoryHeader.statusDisabled"
      }}>
      {!isEnabled && (
        <RouterLink marginRight={3} to={SETTINGS_LOGIN_INTEGRATION} cta marginLeft="7px">
          <FormattedMessage id="admin.containers.manageUsers.peopleDirectoryHeader.statusDisabledLink" />
        </RouterLink>
      )}
    </StatusNotification>
  )
}
export default PeopleDirectoryHeader
